import {
	SET_FORM_STATE,
	GET_ACTIVITIES,
	GET_ACTIVITY,
	GET_ACTIVITY_ELEMENTS,
	GET_TASK,
	GET_ELEMENT_TASK,
	GET_VISIBLE_COLUMNS
} from '../actions/ActivityViewActions.js';

const initialState = {
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	},
	activities: [],
};

const activityViewReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_ACTIVITIES: {
						return {
							...state,
							activities: action.activities
						};
					}
					case GET_ACTIVITY: {
						return {
							...state,
							activity: action.activity
						};
					}
					case GET_ACTIVITY_ELEMENTS: {
						return {
							...state,
							activityElements: action.activityElements
						};
					}
					case GET_TASK: {
						return {
							...state,
							task: action.task
						};
					}
					case GET_ELEMENT_TASK: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.elementTask.details }
							},
							elementTask: action.elementTask

						};
					}
					case GET_VISIBLE_COLUMNS: {
						return {
							...state,
							visibleColumns: action.visibleColumns
						};
					}
					default: {
						return state;
					}
	}
};

export default activityViewReducer;
